import styled from "styled-components";
import { rotateLangArrow } from "../../constants/animationConstants";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 50px;
  margin: 0;

  &:hover {
    cursor: pointer;
  }
`;

export const Flag = styled.img`
  width: 20px;
  margin: 6px 0 0 0;
`;

export const Arrow = styled.img`
  margin-bottom: 4px;
  margin-left: 6px;

  & :active {
    animation: ${rotateLangArrow} 0.2s linear;
  }
`;
